import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/** A small uppercase heading over its body — detail-page sub-sections
 *  (agent detail, bid insights). */
export function LabeledSection({
  title,
  children,
  className,
}: {
  title: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={cn('space-y-2', className)}>
      <h3 className="text-muted-foreground text-xs font-semibold tracking-wider uppercase">{title}</h3>
      {children}
    </section>
  );
}
